import { Pencil, Plug, Plus, Settings, UserRound } from 'lucide-react';

/** One glyph per destination, shared by the menu entry and that page's header so they cannot drift. */
export const menuIcons = {
  profile: UserRound,
  appSettings: Settings,
  siteIntegrations: Plug,
  workspaceEdit: Pencil,
  workspaceCreate: Plus,
} as const;
